import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Form, Collapse, Modal } from 'react-bootstrap';
import { FaMinus } from 'react-icons/fa';
import './campaigncss/Lesson.css';
import axios from 'axios';
import { Add } from '@mui/icons-material';
import { IoIosArrowDown } from "react-icons/io";
import useTranslations from '../transalation/TranslationUtils';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getCampaignDetail, initalCampaignLesson, initalCampaignLessonItem, initCampaignSimpleData, setCampaignSimpleData, setCampaignSimpleDataToCampaignData, setPageModified } from 'app/redux/slices/rdxCampaignSlice';
import { DEFAULT_IP } from "app/utils/constant";

function Lesson() {
    const reasonList = [
        { val_zh: "", val_en: "", zh: "選擇狀況更改原因", en: "Reason" },
        { val_zh: "受惡劣天氣影響", val_en: "poor weather condition", zh: "受惡劣天氣影響", en: "poor weather condition" },
        { val_zh: "因導師生病", val_en: "tutor sick leave", zh: "因導師生病", en: "tutor sick leave" }
    ];

    const dispatch = useDispatch();
    const campaignDetails = useSelector((state) => state.rdxCampaign?.campaignEditData || {});
    const editLesson = useSelector((state) => state.rdxCampaign?.editLesson || initalCampaignLesson);

    const [venuedata, setvenuedataData] = useState([]);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);
    const [showRecurrenceModal, setShowRecurrenceModal] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [recurrenceData, setRecurrenceData] = useState({
        course_name: { zh: '', en: '' },
        venue_id: '',
        start_date: '',
        end_date: '',
        pattern: 'daily', // daily, weekly, monthly
        weekdays: [], // for weekly pattern
        months: [], // for monthly pattern
        start_time: '',
        end_time: '',
        auto_numbering: true // automatically add class sequence numbers
    });


    const { cancel, save, pushstatus, date, venueChinese, lessonDetails,
        lessonNameChinese,
        startTime, selectVenue, courseReasonEmptyHint,
        endTime, role_delete, normal, delayed, cancelled, i18nObj, showErrMsg, showSuccessMsg, role_Add, autoRecurrence, daily, weekly, monthly,
        lessonNameEnglish, classNameEnglish, venueEnglish, recurrencePattern, selectDaysOfWeek, selectMonths, reasonForChange, startDate, endDate, createRecurrenceClasses, translate } = useTranslations();

    const handleShowDeleteModal = (index) => {
        setDeleteIndex(index);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setDeleteIndex(null);
    };

    const handleShowRecurrenceModal = () => {
        setShowRecurrenceModal(true);
    };

    const handleCloseRecurrenceModal = () => {
        setShowRecurrenceModal(false);
        setRecurrenceData({
            course_name: { zh: '', en: '' },
            venue_id: '',
            start_date: '',
            end_date: '',
            pattern: 'daily',
            weekdays: [],
            months: [],
            start_time: '',
            end_time: '',
            auto_numbering: true
        });
    };

    const handleRecurrenceInputChange = (field, value) => {
        setRecurrenceData(prev => {
            const newData = {
                ...prev,
                [field]: value
            };

            // Auto-fill end time when start time is changed and end time is empty
            if (field === 'start_time' && value && !prev.end_time) {
                const [hours, minutes] = value.split(':');
                const startDate = new Date();
                startDate.setHours(parseInt(hours), parseInt(minutes), 0, 0);
                startDate.setHours(startDate.getHours() + 1); // Add 1 hour
                
                const endTimeFormatted = `${String(startDate.getHours()).padStart(2, '0')}:${String(startDate.getMinutes()).padStart(2, '0')}`;
                newData.end_time = endTimeFormatted;
            }

            return newData;
        });
    };

    const handleRecurrenceNameChange = (lang, value) => {
        setRecurrenceData(prev => ({
            ...prev,
            course_name: {
                ...prev.course_name,
                [lang]: value
            }
        }));
    };

    const handleWeekdayChange = (day) => {
        setRecurrenceData(prev => ({
            ...prev,
            weekdays: prev.weekdays.includes(day)
                ? prev.weekdays.filter(d => d !== day)
                : [...prev.weekdays, day]
        }));
    };

    const handleMonthChange = (month) => {
        setRecurrenceData(prev => ({
            ...prev,
            months: prev.months.includes(month)
                ? prev.months.filter(m => m !== month)
                : [...prev.months, month]
        }));
    };

    const generateRecurrentLessons = () => {
        const { course_name, venue_id, start_date, end_date, pattern, weekdays, months, start_time, end_time, auto_numbering } = recurrenceData;
        
        // Validate required fields
        console.log("Recurrence data validation:", { course_name, venue_id, start_date, end_date, start_time, end_time, pattern, weekdays });
        
        if (!course_name.zh || !course_name.en || !venue_id || !start_date || !end_date || !start_time || !end_time) {
            console.log("Validation failed - missing fields:", {
                course_name_zh: !course_name.zh,
                course_name_en: !course_name.en,
                venue_id: !venue_id,
                start_date: !start_date,
                end_date: !end_date,
                start_time: !start_time,
                end_time: !end_time
            });
            alert("Please fill in all required fields");
            return;
        }

        // Additional validation for pattern-specific requirements
        if (pattern === 'weekly' && weekdays.length === 0) {
            alert("Please select at least one weekday");
            return;
        }
        
        if (pattern === 'monthly' && months.length === 0) {
            alert("Please select at least one month");
            return;
        }

        const startDateTime = new Date(start_date);
        const endDateTime = new Date(end_date);
        const newLessons = [];
        let classNumber = 1;

        if (pattern === 'daily') {
            // Generate daily lessons
            const currentDate = new Date(startDateTime);
            while (currentDate <= endDateTime) {
                const lessonDate = new Date(currentDate);
                const startTimestamp = new Date(`${lessonDate.toISOString().split('T')[0]}T${start_time}:00+08:00`).getTime();
                const endTimestamp = new Date(`${lessonDate.toISOString().split('T')[0]}T${end_time}:00+08:00`).getTime();
                
                const courseNameWithClass = auto_numbering ? {
                    zh: `${course_name.zh} (第 ${classNumber} 堂)`,
                    en: `${course_name.en} (Lesson ${classNumber})`
                } : {
                    zh: course_name.zh,
                    en: course_name.en
                };
                
                newLessons.push({
                    ...initalCampaignLessonItem,
                    course_name: courseNameWithClass,
                    venue_id,
                    course_start_time: startTimestamp,
                    course_end_time: endTimestamp,
                    f_date: formatDatelesson(startTimestamp),
                    f_starttime: start_time,
                    f_endtime: end_time,
                    is_update: true,
                    f_open: false,
                    is_recurrence: true // Mark as recurrence class
                });
                
                currentDate.setDate(currentDate.getDate() + 1);
                classNumber++;
            }
        } else if (pattern === 'weekly') {
            // Generate weekly lessons based on selected weekdays
            
            const currentDate = new Date(startDateTime);
            while (currentDate <= endDateTime) {
                const dayOfWeek = currentDate.getDay();
                if (weekdays.includes(dayOfWeek)) {
                    const lessonDate = new Date(currentDate);
                    const startTimestamp = new Date(`${lessonDate.toISOString().split('T')[0]}T${start_time}:00+08:00`).getTime();
                    const endTimestamp = new Date(`${lessonDate.toISOString().split('T')[0]}T${end_time}:00+08:00`).getTime();
                    
                    const courseNameWithClass = auto_numbering ? {
                        zh: `${course_name.zh} (第 ${classNumber} 堂)`,
                        en: `${course_name.en} (Lesson ${classNumber})`
                    } : {
                        zh: course_name.zh,
                        en: course_name.en
                    };
                    
                    newLessons.push({
                        ...initalCampaignLessonItem,
                        course_name: courseNameWithClass,
                        venue_id,
                        course_start_time: startTimestamp,
                        course_end_time: endTimestamp,
                        f_date: formatDatelesson(startTimestamp),
                        f_starttime: start_time,
                        f_endtime: end_time,
                        is_update: true,
                        f_open: false,
                        is_recurrence: true
                    });
                    
                    classNumber++;
                }
                currentDate.setDate(currentDate.getDate() + 1);
            }
        } else if (pattern === 'monthly') {
            // Generate monthly lessons for selected months
            
            const startDay = startDateTime.getDate();
            const currentYear = startDateTime.getFullYear();
            
            months.forEach(month => {
                const lessonDate = new Date(currentYear, month, startDay);
                if (lessonDate >= startDateTime && lessonDate <= endDateTime) {
                    const startTimestamp = new Date(`${lessonDate.toISOString().split('T')[0]}T${start_time}:00+08:00`).getTime();
                    const endTimestamp = new Date(`${lessonDate.toISOString().split('T')[0]}T${end_time}:00+08:00`).getTime();
                    
                    const courseNameWithClass = auto_numbering ? {
                        zh: `${course_name.zh} (第 ${classNumber} 堂)`,
                        en: `${course_name.en} (Lesson ${classNumber})`
                    } : {
                        zh: course_name.zh,
                        en: course_name.en
                    };
                    
                    newLessons.push({
                        ...initalCampaignLessonItem,
                        course_name: courseNameWithClass,
                        venue_id,
                        course_start_time: startTimestamp,
                        course_end_time: endTimestamp,
                        f_date: formatDatelesson(startTimestamp),
                        f_starttime: start_time,
                        f_endtime: end_time,
                        is_update: true,
                        f_open: false,
                        is_recurrence: true
                    });
                    
                    classNumber++;
                }
            });
        }

        // Add new lessons to the course list
        const updatedCourseList = [...editLesson.course_list, ...newLessons];
        let data = {
            data: updatedCourseList,
            projection: "editLesson",
            path: "course_list"
        };
        dispatch(setCampaignSimpleData(data));

        // Close modal and show success message
        handleCloseRecurrenceModal();
        alert(`Successfully created ${newLessons.length} recurring lessons!`);
    };

    // Fetch venues data
    const fetchCampaignVenues = async () => {
        try {
            const response = await axios.get(DEFAULT_IP + "/webapp/memportal/getvenuelist");

            if (response.data.code === 1) {
                setvenuedataData(response.data.data || []);
            } else {
                console.error("API responded with an error:", response.data.message_en);
            }
        } catch (error) {
            console.error("Error fetching campaign venues:", error);
        }
    };

 
    useEffect(() => {
        fetchCampaignVenues();
        initLessonData();
    }, []);

    useEffect(() => {
        initLessonData();
    }, [campaignDetails]);

    const removeLessonFProperties = (obj) => {
        if (Array.isArray(obj)) {
            return obj.map(item => removeLessonFProperties(item));
        } else if (typeof obj === 'object' && obj !== null) {
            return Object.keys(obj).reduce((acc, key) => {
                if (!key.startsWith("f_")) {
                    acc[key] = removeLessonFProperties(obj[key]);
                }
                return acc;
            }, {});
        }
        return obj;
    }


    const initLessonData = () => {
        let newDetails = { ...campaignDetails };

        let isModified = false;
        let newCourseList = [];
        newDetails.course_list?.forEach((course) => {
            let newCourseItem = JSON.parse(JSON.stringify(course));
            newCourseItem.f_date = formatDatelesson(course.course_start_time);
            newCourseItem.f_starttime = formatDate(course.course_start_time, "time");
            newCourseItem.f_endtime = formatDate(course.course_end_time, "time");
            if (course.is_update === undefined) {
                newCourseItem.is_update = false;
            }

            newCourseList.push(newCourseItem);

            if (course.f_modified) {
                isModified = true;
            }
        });

        newDetails.course_list = newCourseList;


        let data = {
            data: newDetails,
            projection: "editLesson",
            type: "obj"
        };
        dispatch(initCampaignSimpleData(data));

        if (isModified) {
            setTimeout(() => {
                dispatch(setPageModified(true));
            });
        }
    }

    // Format date function for mm-dd-yyyy
    const formatDatelessonhome = (timestamp) => {
        if (!timestamp) return "";
        const date = new Date(timestamp);
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();
        return `${month}-${day}-${year}`; // Format as mm-dd-yyyy
    };

    const formatDatelesson = (timestamp) => {
        if (!timestamp) return "";
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`; // Format: yyyy-MM-dd
    };

    // Format time function
    const formatDate = (timestamp, type) => {
        if (!timestamp) return "";
        const date = new Date(timestamp);
        if (isNaN(date.getTime())) return "";

        if (type === "time") {
            const hours = String(date.getHours()).padStart(2, "0");
            const minutes = String(date.getMinutes()).padStart(2, "0");
            return `${hours}:${minutes}`;
        }
        return "";
    };

    const handleToggleCollapse = (origVal, path) => {
        let data = {
            data: !origVal,
            projection: "editLesson",
            path: path,
            noEmit: true
        }
        dispatch(setCampaignSimpleData(data));
    };

    const handleAddNewLesson = () => {
        let newRows = [...editLesson.course_list];
        newRows.push({ ...initalCampaignLessonItem, "f_open": true, "is_update": true });

        let data = {
            data: newRows,
            projection: "editLesson",
            path: "course_list"
        };
        dispatch(setCampaignSimpleData(data));
    };

    const handleSaveLesson = async () => {
        setIsSaving(true);
        
        try {
            let datePass = true;
            let reasonPass = true;
            const payload = removeLessonFProperties(editLesson);

            payload.course_list.forEach((lesson, index) => {
                const courseStartTime = lesson.course_start_time;
                const courseEndTime = lesson.course_end_time;

                if (!courseStartTime || !courseEndTime || courseEndTime <= courseStartTime) {
                    datePass = false;
                }

                if (2 === lesson.course_status || 3 === lesson.course_status) {
                    if (!lesson.reason?.zh || !lesson.reason?.en) {
                        reasonPass = false;
                    }
                }else{
                    if(1 === lesson.course_status){
                        delete lesson.reason;
                    }
                }
            });

            if (!datePass) {
                alert("Invalid start or end time for one or more lessons.");
                return;
            }

            if (!reasonPass) {
                alert(courseReasonEmptyHint());
                return;
            }

            const postRes = await axios.post(DEFAULT_IP + "/webapp/memportal/updatecoursev2", payload);
            let data = postRes.data;
            if (1 === data?.code) {
                alert(showSuccessMsg(data));

                //trigger to refresh new course_id
                dispatch(getCampaignDetail(campaignDetails.campaign_id, (isSuccess, data) => { }));
            } else {
                alert(showErrMsg(data));
            }
        } catch (error) {
            console.error("Error saving lesson:", error);
            alert("An error occurred while saving. Please try again.");
        } finally {
            setIsSaving(false);
        }
    };

    const handleDeleteLesson = async () => {
        let callback = (isSuccess, data) => {
            if (isSuccess) {
                alert("Lesson deleted successfully!");
                handleCloseDeleteModal();

                dispatch((dispatch, getState) => {
                    let newRows = [...editLesson.course_list];
                    newRows.splice(deleteIndex, 1);

                    let data = {
                        data: newRows,
                        projection: "editLesson",
                        path: "course_list",
                        noEmit: true
                    };
                    dispatch(setCampaignSimpleData(data));

                    const latestLesson = getState().rdxCampaign.editLesson;
                    let rData = {
                        data: latestLesson,
                        projection: "self",
                        base: campaignDetails,
                        noEmit: true
                    };
                    dispatch(setCampaignSimpleDataToCampaignData(rData));
                });
            } else {
                alert(showErrMsg(data));
            }
        }

        const courseToDelete = editLesson.course_list[deleteIndex];
        if (courseToDelete.course_id) {
            const payload = {
                campaign_id: campaignDetails.campaign_id,
                course_id: courseToDelete.course_id
            };
            const postRes = await axios.post(DEFAULT_IP + "/webapp/memportal/deletecourse", payload);

            let data = postRes.data;
            if (1 === data?.code) {
                callback(true, data);
            } else {
                callback(false, data);
            }
        } else {
            callback(true, {})
        }
    };

    const handleSelectReason = (e, index, lang) => {
        let zhVal, enVal;

        if ("zh" === lang) {
            let target = reasonList.find(item => item.val_zh === e.target.value);
            if (!target) target = reasonList[0];

            zhVal = e.target.value;
            enVal = target.val_en;
        } else {
            let target = reasonList.find(item => item.val_en === e.target.value);
            if (!target) target = reasonList[0];

            zhVal = target.val_zh;
            enVal = e.target.value;
        }


        handleChangeLesson({ target: { value: zhVal } }, "course_list|" + index + "|reason|zh", index);
        handleChangeLesson({ target: { value: enVal } }, "course_list|" + index + "|reason|en", index);
    }

    const handleChangeLesson = (e, path, index) => {
        const { name, value } = e.target;

        let pass = false;
        let formatVal = undefined;
        if (name === "lessondate" || name === "lessonstarttime" || name === "lessonendtime") {
            let date = undefined;
            let sTime = undefined;
            let eTime = undefined;

            switch (name) {
                case "lessondate": date = value; break;
                case "lessonstarttime": sTime = value; break;
                case "lessonendtime": eTime = value; break;
            }
            if (!date) {
                date = editLesson.course_list[index]?.f_date;
            }
            if (!sTime) {
                sTime = editLesson.course_list[index]?.f_starttime;
            }
            if (!eTime) {
                eTime = editLesson.course_list[index]?.f_endtime;
            }

            // Auto-fill end time when start time is changed and end time is empty
            if (name === "lessonstarttime" && value && !editLesson.course_list[index]?.f_endtime) {
                const [hours, minutes] = value.split(':');
                const startDate = new Date();
                startDate.setHours(parseInt(hours), parseInt(minutes), 0, 0);
                startDate.setHours(startDate.getHours() + 1); // Add 1 hour
                
                const endTimeFormatted = `${String(startDate.getHours()).padStart(2, '0')}:${String(startDate.getMinutes()).padStart(2, '0')}`;
                eTime = endTimeFormatted;
                
                // Update the end time in the store
                let endTimeData = {
                    data: endTimeFormatted,
                    projection: "editLesson",
                    path: "course_list|" + index + "|f_endtime"
                }
                dispatch(setCampaignSimpleData(endTimeData));
            }

            if (date && sTime) {
                let dateData = {
                    data: new Date(`${date}T${sTime}:00+08:00`).getTime(),
                    projection: "editLesson",
                    path: "editLesson|course_list|" + index + "|course_start_time"
                }
                dispatch(setCampaignSimpleData(dateData));
            }

            if (date && eTime) {
                let dateData = {
                    data: new Date(`${date}T${eTime}:00+08:00`).getTime(),
                    projection: "editLesson",
                    path: "editLesson|course_list|" + index + "|course_end_time"
                }
                dispatch(setCampaignSimpleData(dateData));
            }
        } if (name == "lessonstatus") {
            formatVal = parseInt(value, 10);
            pass = true;
        } else {
            formatVal = value;
            pass = true;
        }

        if (pass) {
            let data = {
                data: formatVal,
                projection: "editLesson",
                path: path
            }
            dispatch(setCampaignSimpleData(data));

            let modifiedData = {
                data: true,
                projection: "editLesson",
                path: "editLesson|course_list|" + index + "|f_modified"
            }
            dispatch(setCampaignSimpleData(modifiedData));

            let updateData = {
                data: true,
                projection: "editLesson",
                path: "editLesson|course_list|" + index + "|is_update"
            }
            dispatch(setCampaignSimpleData(updateData));
        }
    };

    return (
        <Container fluid>
            <Row>
                <Card className="mt-0 border-0" style={{ position: "relative" }}>
                    <Row className="align-items-center mb-3">
                        <Col md={6} className="d-flex align-items-center">
                            <h5 className="basicheading">{lessonDetails()}</h5>
                        </Col>
                        <Col md={6} className="text-end">
                            {/* <Button variant="secondary" className="basiccancelbtnn me-2">{cancel()}</Button> */}
                            <Button 
                                variant="primary" 
                                className="basicsavebtn me-3" 
                                onClick={handleSaveLesson}
                                disabled={isSaving}
                            >
                                {isSaving ? translate('儲存中...', 'Saving...') : save()}
                            </Button>
                        </Col>
                    </Row>

                    {/* <Row>
                        <Col md={12}>
                            <Card className="basicinfocard">
                                <CardBody className="d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                        <IoNotificationsOutline className="me-2" size={25} color="#1A73E8" />
                                        <span className="basicstatus">{pushstatus()}: Draft</span>
                                    </div>
                                    <Button className="basicsavebtn " style={{ width: '110px' }} onClick={handleshowBasicModal}>{assignTo()}</Button>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row> */}

                    <Row className="mt-3">
                        {/* Always render the Add button */}
                        <Col md="auto">
                            <Button
                                variant="primary"
                                size="sm"
                                onClick={handleAddNewLesson}
                                style={{
                                    backgroundColor: '#1976D2',
                                    border: 'none',
                                    fontSize: '12px',
                                    marginRight: '8px'
                                }}
                            >
                                {role_Add()}
                            </Button>
                            <Button
                                variant="primary"
                                size="sm"
                                onClick={handleShowRecurrenceModal}
                                style={{
                                    backgroundColor: '#4CAF50',
                                    border: 'none',
                                    fontSize: '12px'
                                }}
                            >
                                {autoRecurrence()}
                            </Button>
                        </Col>

                        {/* Render lesson cards if there are any */}
                        {editLesson.course_list?.map((lesson, index) => (
                            <div key={index}>
                                <Card.Body>
                                    <div
                                        className={`p-3 border rounded d-flex 
                                            justify-content-between align-items-center mb-3 
                                            ${lesson.f_modified ? "lessoncard-modified" : 
                                              lesson.is_recurrence ? "lessoncard-recurrence" : "lessoncard"}`}
                                        style={{
                                            borderColor: lesson.is_recurrence ? '#FF9800' : '#4CAF50',
                                            backgroundColor: lesson.is_recurrence ? '#FFF3E0' : (lesson.f_modified ? '' : '#1c71b2ff')
                                        }}>
                                        <h5 className="mb-0 cardtext" style={{ 
                                            "cursor": "pointer", 
                                            color: lesson.is_recurrence ? '#F57C00' : 'white' 
                                        }} onClick={() => handleToggleCollapse(lesson.f_open, "course_list|" + index + "|f_open")}>
                                            <IoIosArrowDown style={{ color: lesson.is_recurrence ? '#F57C00' : 'white' }} />
                                            &nbsp;&nbsp;
                                            {lesson.is_recurrence && `${autoRecurrence()} - `}
                                            {date()}: {formatDatelessonhome(lesson.course_start_time)}
                                        </h5>
                                        <FaMinus style={{ color: 'white' }} onClick={() => handleShowDeleteModal(index)} />
                                    </div>

                                    <Collapse in={lesson.f_open}>
                                        <div className="p-3">
                                            <Form>
                                                <Row>
                                                    <Col md={6}>
                                                        <Form.Group controlId="introductionChinese" className="floating-label-group">
                                                            <Form.Control
                                                                type="text"
                                                                name="lessonzh"
                                                                className="floating-input"
                                                                value={lesson.course_name?.zh}
                                                                onChange={(e) => handleChangeLesson(e, "course_list|" + index + "|course_name|zh", index)} // Add onChange handler
                                                            />
                                                            <Form.Label className="floating-label">{lessonNameChinese()}</Form.Label>
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={6}>
                                                        <Form.Group controlId="introductionChinese" className="floating-label-group">
                                                            <Form.Control
                                                                type="text"
                                                                name="lessonen"
                                                                className="floating-input"
                                                                value={lesson.course_name?.en}
                                                                onChange={(e) => handleChangeLesson(e, "course_list|" + index + "|course_name|en", index)} // Add onChange handler
                                                            />
                                                            <Form.Label className="floating-label">{lessonNameEnglish()}</Form.Label>
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={6}>
                                                        <Form.Group controlId="campaignNameChinese" className="floating-label-group">
                                                            <Form.Select
                                                                name="venuezh"
                                                                className="floating-input"
                                                                value={lesson.venue_id}
                                                                onChange={(e) => handleChangeLesson(e, "course_list|" + index + "|venue_id", index)} // Add onChange handler
                                                            >
                                                                <option value="">{selectVenue()}</option>
                                                                {venuedata.map((item) => (
                                                                    <option key={item.venue_id} value={item.venue_id}>
                                                                        {item.venue_name.zh}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                            <Form.Label className="floating-label">{venueChinese()}</Form.Label>
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={6}>
                                                        <Form.Group controlId="campaignNameEnglish" className="floating-label-group">
                                                            <Form.Select
                                                                name="venueeng"
                                                                className="floating-input"
                                                                value={lesson.venue_id}
                                                                onChange={(e) => handleChangeLesson(e, "course_list|" + index + "|venue_id", index)} // Add onChange handler
                                                            >
                                                                <option value="">Select Venue (English)</option>
                                                                {venuedata.map((item) => (
                                                                    <option key={item.venue_id} value={item.venue_id}>
                                                                        {item.venue_name.en}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                            <Form.Label className="floating-label">{venueEnglish()}</Form.Label>
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={3}>
                                                        <Form.Group controlId="code" className="floating-label-group">
                                                            <Form.Control
                                                                type="date"
                                                                name="lessondate"
                                                                className="floating-input"
                                                                value={lesson.f_date}
                                                                onChange={(e) => handleChangeLesson(e, "course_list|" + index + "|f_date", index)} // Add onChange handler
                                                            />
                                                            <Form.Label className="floating-label">{date()}</Form.Label>
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={3}>
                                                        <Form.Group controlId="code" className="floating-label-group">
                                                            <Form.Control
                                                                type="time"
                                                                name="lessonstarttime"
                                                                className="floating-input"
                                                                value={lesson.f_starttime}
                                                                onChange={(e) => handleChangeLesson(e, "course_list|" + index + "|f_starttime", index)} // Add onChange handler
                                                            />
                                                            <Form.Label className="floating-label">{startTime()}</Form.Label>
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={3}>
                                                        <Form.Group controlId="code" className="floating-label-group">
                                                            <Form.Control
                                                                type="time"
                                                                name="lessonendtime"
                                                                className="floating-input"
                                                                value={lesson.f_endtime}
                                                                onChange={(e) => handleChangeLesson(e, "course_list|" + index + "|f_endtime", index)} // Add onChange handler
                                                            />
                                                            <Form.Label className="floating-label">{endTime()}</Form.Label>
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={3}>
                                                        <Form.Group controlId="status" className="floating-label-group">
                                                            <Form.Select
                                                                name="lessonstatus"
                                                                className="floating-input"
                                                                value={lesson.course_status}
                                                                onChange={(e) => handleChangeLesson(e, "course_list|" + index + "|course_status", index)} // Add onChange handler
                                                            >


                                                                <option value="1">{normal()}</option>
                                                                <option value="2">{delayed()}</option>
                                                                <option value="3">{cancelled()}</option>
                                                            </Form.Select>
                                                            <Form.Label className="floating-label">{pushstatus()}</Form.Label>
                                                        </Form.Group>
                                                    </Col>

                                                    {(2 === lesson.course_status || 3 === lesson.course_status) && (
                                                        <React.Fragment>
                                                            <Col md={6}>
                                                                <Form.Group controlId="reasonZh" className="floating-label-group">
                                                                    <Form.Select
                                                                        name="reasonZh"
                                                                        className="floating-input"
                                                                        value={lesson.reason?.zh}
                                                                        onChange={(e) => handleSelectReason(e, index, "zh")}
                                                                    >
                                                                        {reasonList.map((item) => (
                                                                            <option key={item.zh} value={item.val_zh}>{item.zh}</option>
                                                                        ))}
                                                                    </Form.Select>
                                                                    <Form.Label className="floating-label">{reasonForChange()}</Form.Label>
                                                                </Form.Group>
                                                            </Col>

                                                            <Col md={6}>
                                                                <Form.Group controlId="reasonEn" className="floating-label-group">
                                                                    <Form.Select
                                                                        name="reasonEn"
                                                                        className="floating-input"
                                                                        value={lesson.reason?.en}
                                                                        onChange={(e) => handleSelectReason(e, index, "en")} // Add onChange handler
                                                                    >
                                                                        {reasonList.map((item) => (
                                                                            <option key={item.en} value={item.val_en}>{item.en}</option>
                                                                        ))}
                                                                    </Form.Select>
                                                                    <Form.Label className="floating-label">{reasonForChange()}</Form.Label>
                                                                </Form.Group>
                                                            </Col>
                                                        </React.Fragment>
                                                    )}
                                                </Row>
                                            </Form>
                                        </div>
                                    </Collapse>
                                </Card.Body>
                            </div>
                        ))}
                    </Row>
                </Card>
            </Row>
            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal} centered>
                <Modal.Body>
                    <p>Do you want to delete this lesson?<br />{i18nObj(editLesson.course_list[deleteIndex]?.course_name)}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="canslebtndialog" onClick={handleCloseDeleteModal}>
                        {cancel()}
                    </Button>
                    <Button className="logoutdialogbtn" onClick={handleDeleteLesson}>
                        {role_delete()}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Recurrence Modal */}
            <Modal show={showRecurrenceModal} onHide={handleCloseRecurrenceModal} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add Recurrence Classes</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>
                            <Col md={6}>
                                <Form.Group  className="mb-3">
                                    <Form.Label>{lessonNameChinese()}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={recurrenceData.course_name.zh}
                                        onChange={(e) => handleRecurrenceNameChange('zh', e.target.value)}
                                        placeholder="輸入課程中文名稱"
                                    />

                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{classNameEnglish()}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={recurrenceData.course_name.en}
                                        onChange={(e) => handleRecurrenceNameChange('en', e.target.value)}
                                        placeholder="Enter class name in English"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{venueChinese()}</Form.Label>
                                    <Form.Select
                                        value={recurrenceData.venue_id}
                                        onChange={(e) => handleRecurrenceInputChange('venue_id', e.target.value)}
                                    >
                                        <option value="">{selectVenue()}</option>
                                        {venuedata.map((item) => (
                                            <option key={item.venue_id} value={item.venue_id}>
                                                {item.venue_name.zh} / {item.venue_name.en}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{recurrencePattern()}</Form.Label>
                                    <Form.Select
                                        value={recurrenceData.pattern}
                                        onChange={(e) => handleRecurrenceInputChange('pattern', e.target.value)}
                                    >
                                        <option value="daily">{daily()}</option>
                                        <option value="weekly">{weekly()}</option>
                                        <option value="monthly">{monthly()}</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{startDate()}</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={recurrenceData.start_date}
                                        onChange={(e) => handleRecurrenceInputChange('start_date', e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{endDate()}</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={recurrenceData.end_date}
                                        onChange={(e) => handleRecurrenceInputChange('end_date', e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{startTime()}</Form.Label>
                                    <Form.Control
                                        type="time"
                                        value={recurrenceData.start_time}
                                        onChange={(e) => handleRecurrenceInputChange('start_time', e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{endTime()}</Form.Label>
                                    <Form.Control
                                        type="time"
                                        value={recurrenceData.end_time}
                                        onChange={(e) => handleRecurrenceInputChange('end_time', e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        {recurrenceData.pattern === 'weekly' && (
                            <Row>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{selectDaysOfWeek()}</Form.Label>
                                        <div className="d-flex flex-wrap gap-2">
                                            {['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map((day, index) => (
                                                <Form.Check
                                                    key={day}
                                                    type="checkbox"
                                                    id={`weekday-${index}`}
                                                    label={day}
                                                    checked={recurrenceData.weekdays.includes(index)}
                                                    onChange={() => handleWeekdayChange(index)}
                                                />
                                            ))}
                                        </div>
                                    </Form.Group>
                                </Col>
                            </Row>
                        )}

                        {recurrenceData.pattern === 'monthly' && (
                            <Row>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{selectMonths()}</Form.Label>
                                        <div className="d-flex flex-wrap gap-2">
                                            {['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].map((month, index) => (
                                                <Form.Check
                                                    key={month}
                                                    type="checkbox"
                                                    id={`month-${index}`}
                                                    label={month}
                                                    checked={recurrenceData.months.includes(index)}
                                                    onChange={() => handleMonthChange(index)}
                                                />
                                            ))}
                                        </div>
                                    </Form.Group>
                                </Col>
                            </Row>
                        )}
                        
                        <Row>
                            <Col md={12}>
                                <Form.Group className="mb-3">
                                    <Form.Check
                                        type="checkbox"
                                        id="auto-numbering"
                                        label={translate('在課程名稱中自動增加課程序號(課堂1,課堂2,課堂3)', 'Automatically add class sequence numbers to course names (Class 1, Class 2, Class 3)')}
                                        checked={recurrenceData.auto_numbering}
                                        onChange={(e) => handleRecurrenceInputChange('auto_numbering', e.target.checked)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseRecurrenceModal}>
                        {cancel()}
                    </Button>
                    <Button variant="primary" onClick={generateRecurrentLessons}>
                        {createRecurrenceClasses()}
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
}

export default Lesson;
